import React, { useEffect, useState } from "react";
import "./header.css";
import { GoHeart } from "react-icons/go";
import { BsCart2 } from "react-icons/bs";
import { IoSearch } from "react-icons/io5";
import { TbMenu2, TbPasswordFingerprint } from "react-icons/tb";
import { FaArrowLeft, FaBoxOpen } from "react-icons/fa6";

import Slider from "react-slick";
import { useDispatch, useSelector } from "react-redux";
import { fetchSettingsData } from "../../../redux/Slice/settingsDataSlice";
import {
    getCategoriesOptionsAPICall,
    getMainCategoryAPICall,
} from "../../../services/CategoryService";
import { BiSolidMessageRoundedDots } from "react-icons/bi";
import { FaUserAlt } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";
import { fetchUserData, setEmptyCard } from "../../../redux/Slice/userDetails";
import { logout } from "../../../services/accountServices";
import { setProductSearchData } from "../../../redux/Slice/searchDataSlice";
import truncateStringe from "../../../common/truncateString";
import { CgLogOut, CgProfile } from "react-icons/cg";
import { PiMapPinLight } from "react-icons/pi";
import ConfirmationDialog from "../../ConfirmationDialog/ConfirmationDialog";
import useNavigateShop from "../../../hooks/useNavigateShop";
import useReducerHook from "../../../hooks/useReducerHook";
import useFindMenuID from "../../../hooks/useFindSlug";
import {
    fetchHeaderMenusData,
    fetchMenuData,
} from "../../../redux/Slice/PageMenu";
import useNavigateMenuId from "../../../hooks/useMenuId";
import { setProfileMenuID } from "../../../redux/Slice/ProfileMenuSlice";
import useNavigateViewProduct from "../../../hooks/useNavigateViewProduct";
import { toast } from "react-toastify";
import { APP_URL } from "../../../shared/baseUrl";

const Header = () => {
    const location = useLocation();
    const token = localStorage.getItem("token");
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { navigateViewProduct } = useNavigateViewProduct();
    const { pageMenus } = useReducerHook();

    const [resposiveSearchOpen, setResposiveSearchOpen] = useState(false);
    const [subCategory, setSubCategory] = useState([]);
    const [mainCategory, setMainCategory] = useState([]);
    const [openMainCategoryId, setOpenMainCategoryId] = useState(null);
    const [isConfirmLogout, setIsConfirmLogout] = useState(false);
    const [openSubCategoryId, setOpenSubCategoryId] = useState(null);
    const settings = {
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        arrows: false,
        autoplayspeed: 1000,
        vertical: true,
    };
    const settingsData = useSelector(
        (state) => state?.settingData?.settingDatas
    );
    const userDetails = useSelector((state) => state?.userDetails?.userDetails);
    const emailOne = settingsData?.find(
        (item) => item?.key_name === "EMAIL_ONE"
    )?.key_value;
    const phonenumberOne = settingsData?.find(
        (item) => item?.key_name === "PHONE_ONE"
    )?.key_value;
    const siterunningwords = settingsData?.find(
        (item) => item?.key_name === "HEADER_ANNOUNCEMENT"
    )?.key_value;
    const siteLogo = settingsData?.find(
        (item) => item?.key_name === "SITE_LOGO"
    )?.key_value;
    useEffect(() => {
        dispatch(fetchSettingsData());
        getMainCategoryData();
        getSubCategoryData();
    }, []);
    useEffect(() => {
        if (token) {
            dispatch(fetchUserData(token));
        }
    }, [token]);

    useEffect(() => {
        dispatch(fetchHeaderMenusData());
        dispatch(fetchMenuData());
    }, [dispatch]);

    const getSubCategoryData = async () => {
        try {
            const response = await getCategoriesOptionsAPICall();
            if (response?.status_code === 200) {
                setSubCategory(response.data);
            }
        } catch (error) {}
    };
    const getMainCategoryData = async () => {
        try {
            const response = await getMainCategoryAPICall();
            if (response?.status_code === 200) {
                setMainCategory(response.data);
            }
        } catch (error) {}
    };

    const handleMainCategoryToggle = (id) => {
        setOpenMainCategoryId(openMainCategoryId === id ? null : id);
        setOpenSubCategoryId(null);
    };

    const handleSubCategoryToggle = (id) => {
        setOpenSubCategoryId(openSubCategoryId === id ? null : id);
    };
    let viewshopID = useFindMenuID(pageMenus?.menuData, "shop");

    const handleShopPageNavigate = (productDetails) => {
        navigateViewProduct(productDetails, viewshopID);

        // navigate("/shop", { state: { productid: product_id } });
    };

    const isActive = (path) => location.pathname === path;
    const handleLogout = async () => {
        try {
            const response = await logout(token);
            if (response.status_code === 200) {
                localStorage.removeItem("token");
                dispatch(setEmptyCard());
                navigate("/");
                setIsConfirmLogout(false);
                toast.success("Logout Successfully");
            }
        } catch (error) {}
    };
    const handleProductSearch = (values) => {
        navigatePageId(shopPage);
        dispatch(setProductSearchData(values));
    };

    const shopPage = useFindMenuID(pageMenus?.menuData, "shop");
    const contactUs = useFindMenuID(pageMenus?.menuData, "contact-us");
    const loginPage = useFindMenuID(pageMenus?.menuData, "login");
    let cartPage = useFindMenuID(pageMenus?.menuData, "cart");
    let wishlistPage = useFindMenuID(pageMenus?.menuData, "wish_list");
    let accountPage = useFindMenuID(pageMenus?.menuData, "account");

    const { navigatePageId } = useNavigateMenuId();

    function reWriteHeader() {
        let data = pageMenus?.headerMenuData?.map((x) => {
            return {
                ...x,
                page_slug: x?.page_slug === "home" ? "" : x?.page_slug,
            };
        });

        return data;
    }
    return (
        <>
            <header>
                <div className="container-fluid first-header py-3">
                    <div className="container">
                        <marquee>{siterunningwords}</marquee>
                    </div>
                </div>

                <div
                    className="container-fluid second-header d-flex justify-content-lg-between justify-content-sm-end justify-content-md-end justify-content-end  align-items-center px-2"
                    style={{ height: "50px" }}
                >
                    <div className="d-flex align-items-center d-none d-md-flex d-lg-flex col-lg-5 col-8">
                        <span title={emailOne}>
                            {/* <p className="fs-6 m-0" title={emailOne}> */}
                            {/* {truncateStringe(emailOne)}  */}
                            {emailOne}
                            {/* </p> */}
                        </span>
                        <div className="vr text-white mx-3 mx-sm-1"></div>
                        <span className="mobilenumber">{phonenumberOne}</span>
                    </div>

                    <div className="d-flex col-3 col-lg-4 justify-content-around align-items-center">
                        <div
                            className="text-center d-lg-block d-none pointer text-uppercase "
                            onClick={() => navigatePageId(contactUs)}
                        >
                            {" "}
                            <BiSolidMessageRoundedDots />
                            Contact Us
                        </div>
                        <div className="vr text-white mx-3 d-lg-block  d-none"></div>
                        {userDetails?.full_name ? (
                            <div className="text-center d-flex align-items-center user-dropdown">
                                <FaUserAlt style={{ marginRight: "5px" }} />
                                {userDetails?.full_name}

                                <div className="dropdown-content ">
                                    <div
                                        onClick={() => {
                                            navigatePageId(accountPage);
                                            dispatch(setProfileMenuID(1));
                                        }}
                                    >
                                        <CgProfile
                                            style={{ marginRight: "5px" }}
                                        />
                                        My Account
                                    </div>
                                    <div
                                        onClick={() => {
                                            navigatePageId(accountPage);
                                            dispatch(setProfileMenuID(2));
                                        }}
                                    >
                                        <FaBoxOpen
                                            style={{ marginRight: "2px" }}
                                        />{" "}
                                        <span className="fs-6">
                                            Order Information
                                        </span>
                                    </div>
                                    <div
                                        onClick={() => {
                                            navigatePageId(accountPage);
                                            dispatch(setProfileMenuID(3));
                                        }}
                                    >
                                        <PiMapPinLight
                                            style={{ marginRight: "5px" }}
                                        />
                                        Address{" "}
                                    </div>
                                    <div
                                        onClick={() => {
                                            navigatePageId(accountPage);
                                            dispatch(setProfileMenuID(4));
                                        }}
                                    >
                                        <TbPasswordFingerprint
                                            style={{ marginRight: "5px" }}
                                        />
                                        Change Password
                                    </div>
                                    <div
                                        className="logout"
                                        onClick={() => setIsConfirmLogout(true)}
                                    >
                                        <CgLogOut
                                            style={{ marginRight: "5px" }}
                                        />{" "}
                                        Logout
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div
                                className="text-center d-flex align-items-center pointer text-uppercase "
                                onClick={() => navigatePageId(loginPage)}
                            >
                                <FaUserAlt style={{ marginRight: "5px" }} />
                                Login
                            </div>
                        )}
                        <div className="vr text-white mx-3 d-lg-block  d-none"></div>
                        <div
                            className="text-center d-lg-block d-none position-relative pointer"
                            title="Cart"
                            onClick={() => navigatePageId(cartPage)}
                        >
                            <BsCart2 size={20} />
                            {userDetails?.cart_count > 0 && (
                                <span
                                    className="position-absolute top-0 start-100 translate-middle badge rounded-pill "
                                    style={{
                                        fontSize: "0.7rem",
                                        background: `var(--primary-color-gentlemenz)`,
                                    }}
                                >
                                    {token ? userDetails?.cart_count : 0}
                                </span>
                            )}
                        </div>
                        <div className="vr text-white mx-3 d-lg-block  d-none"></div>
                        <div
                            className="text-center d-lg-block  d-none pointer"
                            title="Wishlist"
                            onClick={() => navigatePageId(wishlistPage)}
                        >
                            <GoHeart size={24} />
                        </div>
                    </div>
                </div>

                <div className="container-fluid third-header px-auto d-lg-flex d-none align-items-center">
                    <div className="col-12 col-lg-2">
                        <img
                            className="img-fluid pointer"
                            width={150}
                            src={APP_URL + siteLogo}
                            alt="site-logo"
                            onClick={() => navigate("/")}
                        />
                    </div>
                    <div className="col-12 col-lg-6 mt-2 mt-lg-0">
                        <ul className="d-flex justify-content-evenly flex-wrap">
                            {mainCategory?.map((item) => {
                                const filteredSubCategories =
                                    subCategory?.filter(
                                        (subItem) =>
                                            subItem?.parent_id === item?.id
                                    );
                                return (
                                    <li
                                        key={item?.id}
                                        className="category-item"
                                    >
                                        <span className="site-hover">
                                            {item?.category_name}
                                        </span>
                                        {filteredSubCategories?.length > 0 && (
                                            <div
                                                className="submenu-hover"
                                                style={{ zIndex: 9999 }}
                                            >
                                                {filteredSubCategories.map(
                                                    (subCategoryFilter) => {
                                                        const childCategories =
                                                            subCategory?.filter(
                                                                (
                                                                    childCategory
                                                                ) =>
                                                                    childCategory?.parent_id ===
                                                                    subCategoryFilter.id
                                                            );

                                                        return (
                                                            <div
                                                                key={
                                                                    subCategoryFilter.id
                                                                }
                                                                className="submen-diss"
                                                            >
                                                                <span
                                                                    className="fs-5 pointer"
                                                                    style={{
                                                                        color: "var(--primary-color-gentlemenz)",
                                                                    }}
                                                                    onClick={() =>
                                                                        handleShopPageNavigate(
                                                                            {
                                                                                product_id:
                                                                                    subCategoryFilter?.id,
                                                                            }
                                                                        )
                                                                    }
                                                                >
                                                                    {
                                                                        subCategoryFilter?.category_name
                                                                    }
                                                                </span>
                                                                {childCategories?.length >
                                                                    0 && (
                                                                    <ul>
                                                                        {childCategories.map(
                                                                            (
                                                                                childValue
                                                                            ) => (
                                                                                <li
                                                                                    key={
                                                                                        childValue.id
                                                                                    }
                                                                                >
                                                                                    <span
                                                                                        className="fs-6 pointer"
                                                                                        onClick={() =>
                                                                                            handleShopPageNavigate(
                                                                                                {
                                                                                                    product_id:
                                                                                                        childValue?.id,
                                                                                                }
                                                                                            )
                                                                                        }
                                                                                    >
                                                                                        {
                                                                                            childValue.category_name
                                                                                        }
                                                                                    </span>
                                                                                </li>
                                                                            )
                                                                        )}
                                                                    </ul>
                                                                )}
                                                            </div>
                                                        );
                                                    }
                                                )}
                                            </div>
                                        )}
                                    </li>
                                );
                            })}
                            {reWriteHeader()?.map((item, index) => (
                                <li
                                    key={item?.page_id}
                                    className={`pointer site-hover ${
                                        `/${item?.page_slug}` ===
                                        location?.pathname
                                            ? "active-link fw-bold"
                                            : ""
                                    }`}
                                >
                                    <span
                                        onClick={() => {
                                            if (item?.page_slug === "home") {
                                                navigate(`/`, {
                                                    state: {
                                                        page_id: item?.page_id,
                                                    },
                                                });
                                            } else {
                                                navigate(
                                                    `/${item?.page_slug}`,
                                                    {
                                                        state: {
                                                            page_id:
                                                                item?.page_id,
                                                        },
                                                    }
                                                );
                                            }
                                        }}
                                        style={{ textTransform: "capitalize" }}
                                    >
                                        {item?.name}
                                    </span>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="col-12 col-lg-4">
                        <div className="row col-12 col-lg-11 search-bar">
                            <div className="d-flex justify-content-between align-items-center p-0 mb-2">
                                <span className="col-lg-1 col-2">
                                    <IoSearch />
                                </span>
                                <div className="col-lg-6 col-9">
                                    <input
                                        className="w-100 border-0"
                                        placeholder="Search"
                                        type="text"
                                        onChange={(e) =>
                                            handleProductSearch(
                                                e?.target?.value
                                            )
                                        }
                                    />
                                </div>
                                <div className="col-lg-4">
                                    <Slider {...settings}>
                                        {subCategory?.map((item) => (
                                                <span
                                                key={item?.id}
                                                    className="pointer"
                                                    onClick={() =>
                                                        handleShopPageNavigate({
                                                            product_id:
                                                                item?.id,
                                                        })
                                                    }
                                                >
                                                    {item?.category_name}
                                                </span>
                                        ))}
                                    </Slider>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Mobile Responsive */}
                <div className="mobile-responsive d-lg-none">
                    <div className="row justify-content-between align-items-center m-0">
                        <div className="col-2 fs-1">
                            <span
                                data-bs-toggle="offcanvas"
                                data-bs-target="#staticBackdrop"
                                aria-controls="staticBackdrop"
                            >
                                <TbMenu2 />
                            </span>
                        </div>
                        <div className="col-6 d-flex justify-content-center">
                            <img
                                className="img-fluid pointer"
                                width={150}
                                src={APP_URL + siteLogo}
                                alt="site-logo"
                                onClick={() => navigate("/")}
                            />
                        </div>
                        <div className="col-2 fs-1 d-flex justify-content-end">
                            <span
                                onClick={() =>
                                    setResposiveSearchOpen(!resposiveSearchOpen)
                                }
                            >
                                <IoSearch />
                            </span>
                        </div>

                        {/* Search Bar mobile responsive */}
                        {resposiveSearchOpen && (
                            <div className="col-10 mx-auto mt-4">
                                <div className="row col-12 col-lg-11 search-bar">
                                    <div className="d-flex justify-content-between align-items-center p-0 mb-2">
                                        <span className="col-2">
                                            <IoSearch />
                                        </span>
                                        <div className="col-6">
                                            <input
                                                className="w-100 border-0"
                                                placeholder="Search"
                                                type="text"
                                                onChange={(e) =>
                                                    handleProductSearch(
                                                        e?.target?.value
                                                    )
                                                }
                                            />
                                        </div>
                                        <div className="col-4">
                                            <Slider {...settings}>
                                                {subCategory?.map((item) => (
                                                    <div>
                                                        <span>
                                                            {
                                                                item?.category_name
                                                            }
                                                        </span>
                                                    </div>
                                                ))}
                                            </Slider>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Menu Mobile responsive */}
                        <div
                            className="offcanvas offcanvas-start"
                            data-bs-backdrop="static"
                            tabIndex={-1}
                            id="staticBackdrop"
                            aria-labelledby="staticBackdropLabel"
                        >
                            <div className="offcanvas-header">
                                <h5
                                    className="offcanvas-title"
                                    id="staticBackdropLabel"
                                >
                                    <button
                                        type="button"
                                        className="border-0 bg-transparent"
                                        data-bs-dismiss="offcanvas"
                                        aria-label="Close"
                                    >
                                        <FaArrowLeft />
                                    </button>
                                </h5>
                            </div>
                            <div className="offcanvas-body">
                                <ul className="category-list">
                                    {mainCategory?.map((item) => (
                                        <li
                                            key={item?.id}
                                            className="category-iteme"
                                        >
                                            <div className="category">
                                                <h2
                                                    className="main-category"
                                                    style={{
                                                        color: "var( --secondry-color-gentlemenz) !important",
                                                    }}
                                                >
                                                    {item?.category_name}
                                                </h2>
                                                {openMainCategoryId ===
                                                    item.id && (
                                                    <div className="subcategory-list">
                                                        {subCategory
                                                            ?.filter(
                                                                (subItem) =>
                                                                    subItem?.parent_id ===
                                                                    item?.id
                                                            )
                                                            .map(
                                                                (
                                                                    subCategoryFilter
                                                                ) => (
                                                                    <div
                                                                        key={
                                                                            subCategoryFilter.id
                                                                        }
                                                                        className="subcategory"
                                                                    >
                                                                        <h3
                                                                            onClick={() => {
                                                                                handleSubCategoryToggle(
                                                                                    subCategoryFilter.id
                                                                                );

                                                                                handleShopPageNavigate(
                                                                                    {
                                                                                        product_id:
                                                                                            subCategoryFilter?.id,
                                                                                    }
                                                                                );
                                                                            }}
                                                                            className="sub-category"
                                                                            style={{
                                                                                color: "var( --hover-color-gentlemenz) !important",
                                                                            }}
                                                                        >
                                                                            {
                                                                                subCategoryFilter?.category_name
                                                                            }
                                                                        </h3>

                                                                        {openSubCategoryId ===
                                                                            subCategoryFilter.id && (
                                                                            <div className="child-categories">
                                                                                <ul>
                                                                                    {subCategory
                                                                                        ?.filter(
                                                                                            (
                                                                                                childCategory
                                                                                            ) =>
                                                                                                childCategory?.parent_id ===
                                                                                                subCategoryFilter.id
                                                                                        )
                                                                                        .map(
                                                                                            (
                                                                                                childValue
                                                                                            ) => (
                                                                                                <li
                                                                                                    key={
                                                                                                        childValue.id
                                                                                                    }
                                                                                                    className="child-category-iteme"
                                                                                                >
                                                                                                    <span
                                                                                                        className="child-category"
                                                                                                        style={{
                                                                                                            color: "var(--default-text-color-gentlemenz) !important",
                                                                                                        }}
                                                                                                        onClick={() =>
                                                                                                            handleShopPageNavigate(
                                                                                                                {
                                                                                                                    product_id:
                                                                                                                        childValue?.id,
                                                                                                                }
                                                                                                            )
                                                                                                        }
                                                                                                    >
                                                                                                        {
                                                                                                            childValue.category_name
                                                                                                        }
                                                                                                    </span>
                                                                                                </li>
                                                                                            )
                                                                                        )}
                                                                                </ul>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                )
                                                            )}
                                                    </div>
                                                )}
                                            </div>
                                        </li>
                                    ))}
                                    {reWriteHeader()?.map((item, index) => (
                                        <li
                                            key={item?.page_id}
                                            className={`additional-links pointer ${
                                                `/${item?.page_slug}` ===
                                                location?.pathname
                                                    ? "active-link fw-bold"
                                                    : ""
                                            }`}
                                            data-bs-dismiss="offcanvas"
                                            aria-label="Close"
                                        >
                                            <span
                                                onClick={() => {
                                                    if (
                                                        item?.page_slug ===
                                                        "home"
                                                    ) {
                                                        navigate(`/`, {
                                                            state: {
                                                                page_id:
                                                                    item?.page_id,
                                                            },
                                                        });
                                                    } else {
                                                        navigate(
                                                            `/${item?.page_slug}`,
                                                            {
                                                                state: {
                                                                    page_id:
                                                                        item?.page_id,
                                                                },
                                                            }
                                                        );
                                                    }
                                                }}
                                                style={{
                                                    textTransform: "capitalize",
                                                }}
                                            >
                                                {item?.name}
                                            </span>
                                        </li>
                                    ))}

                                    <li
                                        className="additional-links pointer"
                                        onClick={() =>
                                            navigatePageId(wishlistPage)
                                        }
                                        data-bs-dismiss="offcanvas"
                                        aria-label="Close"
                                    >
                                        Wishlist
                                    </li>
                                    <li
                                        className="additional-links pointer"
                                        onClick={() => navigatePageId(cartPage)}
                                        data-bs-dismiss="offcanvas"
                                        aria-label="Close"
                                    >
                                        Cart
                                    </li>
                                    {token && (
                                        <>
                                            <li
                                                className="additional-links pointer"
                                                onClick={() => {
                                                    dispatch(
                                                        setProfileMenuID(1)
                                                    );
                                                    navigatePageId(accountPage);
                                                }}
                                                data-bs-dismiss="offcanvas"
                                                aria-label="Close"
                                            >
                                                My Account
                                            </li>
                                            <li
                                                className="additional-links pointer"
                                                onClick={() => {
                                                    dispatch(
                                                        setProfileMenuID(2)
                                                    );
                                                    navigatePageId(accountPage);
                                                }}
                                                data-bs-dismiss="offcanvas"
                                                aria-label="Close"
                                            >
                                                Order Information
                                            </li>
                                            <li
                                                className="additional-links pointer"
                                                onClick={() => {
                                                    dispatch(
                                                        setProfileMenuID(3)
                                                    );
                                                    navigatePageId(accountPage);
                                                }}
                                                data-bs-dismiss="offcanvas"
                                                aria-label="Close"
                                            >
                                                Address Book
                                            </li>
                                            <li
                                                className="additional-links pointer"
                                                onClick={() => {
                                                    dispatch(
                                                        setProfileMenuID(4)
                                                    );
                                                    navigatePageId(accountPage);
                                                }}
                                                data-bs-dismiss="offcanvas"
                                                aria-label="Close"
                                            >
                                                Change Password
                                            </li>
                                            <li
                                                className="additional-links pointer"
                                                onClick={() =>
                                                    setIsConfirmLogout(true)
                                                }
                                                data-bs-dismiss="offcanvas"
                                                aria-label="Close"
                                            >
                                                Logout
                                            </li>
                                        </>
                                    )}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                {isConfirmLogout && (
                    <ConfirmationDialog
                        onClose={() => setIsConfirmLogout(false)}
                        handleDelete={() => handleLogout()}
                        primaryText={"Want to logout?"}
                        actiontext={"Yes,Logout!"}
                    />
                )}
            </header>
        </>
    );
};

export default Header;
